import moment from 'moment-timezone';
import {isEmpty as _isEmpty, map as _map} from 'lodash';
import React from 'react';

import {isValidJiraTicketNumber} from '@utils/helpers';

export const getClassNameForDatesCells = (startDate, endDate) => {
    const todayDate = moment().format('YYYY-MM-DD');

    if (todayDate > endDate) {
        return '--is-disabled';
    } else if (todayDate < startDate) {
        return '--is-upcoming';
    }

    return null;
};

export const renderClientPackagesGeoRestriction = (clientGeoRestrictions) => {
    return (
        <div>
            {!(_isEmpty(clientGeoRestrictions))
                ? 'Specific'
                : 'Same as client product settings'}
        </div>
    );
};

export const renderEventContentVariants = (column, row) => {
    return _map(row[column], (eventContentVariant) => eventContentVariant.name).join(', ');
};

export const renderContentActivationTicketNumber = (column, row) => {
    const ticketNumber = row[column],
        url = `https://sportradar.atlassian.net/browse/${ticketNumber}`;

    return isValidJiraTicketNumber(ticketNumber)
        ? <a href={url} target='_blank' rel='noopener noreferrer'>{ticketNumber.toUpperCase()}</a>
        : ticketNumber;
};

const parseRestoredDate = (value) => {
    if (!value) {
        return null;
    }

    const date = moment.isMoment(value) ? value : moment(value);

    return date.isValid() ? date : null;
};

export const buildInitialDatesState = (filters, restoreFilterDateValues) => {
    const nextState = {
        fromMaxDate: null,
        fromMaxDateDefault: null,
        fromMaxTime: null,
        toMinDate: null,
        toMinDateDefault: null,
        toMinTime: null,
    };
    const fromMaxDate = parseRestoredDate(restoreFilterDateValues(filters.ClientPackages, 'to', null));
    const toMinDate = parseRestoredDate(restoreFilterDateValues(filters.ClientPackages, 'from', null));

    if (fromMaxDate) {
        nextState.fromMaxDateDefault = fromMaxDate;
        nextState.fromMaxDate = fromMaxDate;
    }

    if (toMinDate) {
        nextState.toMinDateDefault = toMinDate;
        nextState.toMinDate = toMinDate;
    }

    if (
        nextState.fromMaxDateDefault &&
        nextState.toMinDateDefault &&
        nextState.fromMaxDateDefault.format('YYYY-MM-DD') === nextState.toMinDateDefault.format('YYYY-MM-DD')
    ) {
        nextState.fromMaxTime = fromMaxDate;
        nextState.toMinTime = toMinDate;
    }

    return nextState;
};
